import { render } from "./customerList.vue?vue&type=template&id=4f129118&scoped=true"
import script from "./customerList.vue?vue&type=script&lang=js"
export * from "./customerList.vue?vue&type=script&lang=js"

import "./customerList.vue?vue&type=style&index=0&id=4f129118&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f129118"]])

export default __exports__